import React, { useState, useEffect } from 'react';
import '../../css/noMatch.css';
import { Link, useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import imgNoMatch from '../../assets/svg/mainImgNoMatch.svg'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';
import CustomBreadcrumbs from '../../components/Breadcrumbs/CustomBreadcrumbs';

function NoMatch() {

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);


  return ( 
    <>
        <Header/> 
        { isLoading ? 
        <GifAnim />
        :
        <div className={ isTablet ? "mainViewContainerNoMatch" : "mainViewContainerNoMatchMobile"}>
            <div className={ isTablet ? 'firstTxtViewContainerNoMatch' : 'firstTxtViewContainerNoMatchMobile' }>
                <div className='mainHeadingViewContainerNoMatch'>           
                    <CustomBreadcrumbs goHome />
                    <div className={ isTablet ? 'titleSaldoContainerHomeSteps' : ( isMobile ? 'titleSaldoContainerHomeStepsTablet' : 'titleSaldoContainerHomeStepsMobile')}>
                        <Heading hasSaldo={false} hasBtnBack={false} />
                    </div>
                </div>
                <div className={ isTablet ? 'secondMainContainerNoMatch' : 'secondMainContainerNoMatchMobile' } >
                    <div className='mainTxtViewContainerNoMatch'>
                        <div className='txtMainInfoTitleNoMatch'>ERRO 404</div>
                        <div className='txtViewContainerNoMatch'>
                            <div className={ isTablet ? 'txtMainTitleNoMatch' : 'txtMainTitleNoMatchMobile' }>Esta página está a precisar de um check-up!</div>
                            <div className='mainSubTxtViewContainerNoMatch'>
                                <span className='mainTxtNoMatch'>Não conseguimos encontrar aquilo que procura. Por favor, verifique se o endereço está escrito corretamente. Pode também </span>
                                <Link to="/" className="linkNoMatch">
                                    <span className='mainTxtNavNoMatch'>voltar à Homepage</span>
                                </Link>
                                <span className='mainTxtNoMatch'>.</span>
                            </div>
                        </div>

                    </div>
                    <div className={ isTablet ? 'mainImgViewNoMatch' : 'mainImgViewNoMatchMobile'}>
                        <img src={imgNoMatch} alt="imagem" className={ isTablet ? 'mainImgNoMatch' : 'mainImgNoMatchMobile' } />
                    </div>
                </div>
            </div>
        </div>
        }
        <Footer/> 
    </>
  )
}

export default NoMatch;